// Ui::SecretFieldComponent controller
// Handles show/hide toggle for write-only secret / password inputs.
// Never populates the field value from stored data — that is enforced
// server-side by the component (write-only contract).

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "eyeIcon", "eyeOffIcon"]
  static values = { visible: Boolean }

  toggle() {
    this.visibleValue = !this.visibleValue
    this.inputTarget.type = this.visibleValue ? "text" : "password"
    this.eyeIconTarget.classList.toggle("hidden", this.visibleValue)
    this.eyeOffIconTarget.classList.toggle("hidden", !this.visibleValue)
  }
}
